// extracted by mini-css-extract-plugin
module.exports = {"root":"article-content-styles_root__flaa7"};